import React from 'react'
import { useHistory } from 'react-router-dom'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { useTranslation } from 'react-i18next'

const AuthButtonLists = ({ title, go, action, style, textStyle }: any) => {
	const navigation = useHistory()
	const { t } = useTranslation()
	return (
		<CButton
			title={t(title)}
			onClick={() => {
				if (action) {
					action()
				} else {
					navigation.push(go)
				}
			}}
			textStyle={{ color: COLORS.lightGray5, ...textStyle }}
			style={{
				fontWeight: '500',
				alignSelf: 'flex-start',
				color: COLORS.black,
				fontSize: 10,
				cursor: 'pointer',
				...style,
			}}
			textHover={COLORS.primary}
		/>
	)
}

export default React.memo(AuthButtonLists)
